export default __webpack_public_path__ + "static/media/third.e1f435e5.png";